/**
 * Created by slava on 5/8/17.
 */

const DataLoader = function () {
    this.enabled = true;
    this.onBeforeSaveListener = function () {};
    this.checksum = 0;
    this._queue = {};

    const prefix = this.getLocalStoragePrefix();

    Object.keys(DataLoader.TYPES).forEach((key) => {
        DataLoader.TYPES[key] = prefix + DataLoader.TYPES[key];
    });

    connector.cloudStorage.on("conflict", () => this.onCloudConflict());
    connector.cloudStorage.on("disable", () => this.onCloudDisable());
};

DataLoader.prototype.initialize = function () {
    this.localStorage = connector.dataLoader.getLocalStorage();

    const prefix = this.getLocalStoragePrefix();

    this.data = this.localStorage.getData(prefix);

    const storageChecksum = this.loadChecksum();

    for (const key in this.data) {
        this.addChecksum(key, this.data[key]);
    }

    const userInfo = this.load(DataLoader.TYPES.ID);
    if (userInfo) {
        this.hadUserFromStart = true;
    } else {
        this.hadUserFromStart = false;
    }

    const hasChecksum = this.hasKey(DataLoader.TYPES.CHECKSUM) || Version.compare("1.237.0", userInfo && userInfo.version) < 0;
    if (hasChecksum) {
        this.checksumMatch = this.checksum === storageChecksum;
        if (!this.checksumMatch) {
            if (cleverapps.config.debugMode) {
                console.error(`checksum different storage - ${storageChecksum}, actual - ${this.checksum}`);
            } else {
                console.log("checksum different");
            }
        }
    }

    this.saveChecksum();

    cleverapps.timeouts.setInterval(() => this.processSaveQueue(), 1000);

    // a reload, a closed tab or an app switch can come within the second the queue waits, and the change made in it is lost
    connector.platform.on("pause", () => this.processSaveQueue());
};

DataLoader.prototype.setEnabled = function (enabled) {
    this.enabled = Boolean(enabled);
};

DataLoader.prototype.haveSavedData = function () {
    const data = this.load(DataLoader.TYPES.ID);
    if (connector.platform.oneOf(connector.GDCOM, connector.COOLMATHGAMES) && connector._gdComOldId) {
        return Boolean(data && data.id === connector._gdComOldId);
    }
    return data !== undefined;
};

DataLoader.prototype.save = function (key, data, options) {
    if (key === undefined || data === undefined) {
        const errorMessage = `save undefined key or data - ${key}`;
        if (cleverapps.config.debugMode) {
            cleverapps.throwAsync(errorMessage);
        } else {
            console.warn(errorMessage);
        }
    }

    this._queue[key] = {
        data,
        options
    };
};

DataLoader.prototype.processSaveQueue = function () {
    this.onBeforeSaveListener();

    let changed = false;

    for (const key in this._queue) {
        changed = true;

        if (this._queue[key].data === DataLoader.REMOVE) {
            this._removeProcess(key, this._queue[key].options);
        } else {
            this._saveProcess(key, this._queue[key].data, this._queue[key].options);
        }
    }

    if (changed) {
        this._queue = {};
        this.saveChecksum();
    }
};

DataLoader.prototype._saveProcess = function (key, data, options) {
    options = options || {};
    const raw = options.raw;

    let string;

    try {
        string = raw ? (`${data}`) : JSON.stringify(data);
    } catch (e) {
        console.log(`error stringify - ${key}`, data);
        throw e;
    }

    this.addChecksum(key, this.data[key]);
    this.addChecksum(key, string);
    this.data[key] = string;

    if (!this.enabled) {
        return;
    }

    try {
        if (key !== DataLoader.TYPES.CLIENT_SESSION && this.data[DataLoader.TYPES.CLIENT_SESSION] && !this.localStorage.getItem(DataLoader.TYPES.CLIENT_SESSION)) {
            cleverapps.metrics && cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.CLEARANCE.LOCALSTORAGE_CLEARED);
            throw 1;
        }

        if (string && string.length > DataLoader.VALUE_LENGTH_LIMIT) {
            cleverapps.throwAsync(`Attempt to save huge value (${string.length}) to localstorage key - ${key}`);
        }

        this.localStorage.setItem(key, string);

        if (!connector.info.isNative && this.localStorage.getItem(key) !== string) {
            if (key !== DataLoader.TYPES.CLIENT_SESSION) {
                cleverapps.metrics && cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.CLEARANCE.LOCALSTORAGE_ERROR_SET_ITEM);
            }
            throw 2;
        }
    } catch (e) {
        this.setEnabled(false); // not save data to localstorage anymore
        connector.dataLoader.setEnabled(false);
    }
};

DataLoader.prototype.getCharValues = function (params) {
    const values = [];
    let charCode;
    for (let i = 0; i < params.str.length; i++) {
        charCode = params.str.charCodeAt(i);
        if (params.encode) {
            values.push(charCode <= 65517 ? charCode + 18 : charCode);
        } else {
            values.push(charCode <= 65535 ? charCode - 18 : charCode);
        }
    }
    return values;
};

DataLoader.prototype.hasKey = function (key) {
    let stored;
    if (this._queue[key]) {
        stored = this._queue[key].data;
    } else {
        // eslint-disable-next-line no-prototype-builtins
        if (!this.data.hasOwnProperty(key)) {
            this.data[key] = this.localStorage.getItem(key);
        }
        stored = this.data[key];
    }
    return stored !== null && stored !== undefined;
};

DataLoader.prototype.listExistingKeys = function (prefix) {
    const keys = {};

    Object.keys(this._queue).forEach((key) => {
        if (key.indexOf(prefix) === 0) {
            keys[key] = true;
        }
    });

    Object.keys(this.data).forEach((key) => {
        if (key.indexOf(prefix) === 0) {
            keys[key] = true;
        }
    });

    return Object.keys(keys);
};

DataLoader.prototype.load = function (key, options) {
    if (this._queue[key]) {
        let data = this._queue[key].data;
        if (data === DataLoader.REMOVE) {
            return undefined;
        }

        const queueRaw = this._queue[key].options && this._queue[key].options.raw;
        const optionsRaw = options && options.raw;

        data = queueRaw ? (`${data}`) : data;
        return optionsRaw && !queueRaw ? JSON.stringify(data) : data;
    }
    // eslint-disable-next-line no-prototype-builtins
    if (!this.data.hasOwnProperty(key) && (this.enabled || key === DataLoader.TYPES.GIT)) {
        this.data[key] = this.localStorage.getItem(key);
    }
    const stored = this.data[key];
    if (stored !== null && stored !== undefined && stored !== "undefined") {
        if (options && options.raw) {
            return stored;
        }

        let storedData;
        try {
            storedData = JSON.parse(stored);
            if (storedData && storedData.dataCodes) {
                const values = this.getCharValues({ str: storedData.dataCodes });
                storedData = JSON.parse(String.fromCharCode.apply(null, values));
            }
        } catch (e) {
            cleverapps.throwAsync(`DataLoader.load broken value for key ${key} (${stored.length} chars): ${e.message}`);
            return undefined;
        }
        return storedData;
    }

    return undefined;
};

DataLoader.prototype.remove = function (key) {
    if (!this.hasKey(key)) {
        return;
    }

    this._queue[key] = {
        data: DataLoader.REMOVE
    };
};

DataLoader.prototype._removeProcess = function (key) {
    if (this._queue[key]) {
        delete this._queue[key];
    }
    this.addChecksum(key, this.data[key]);
    delete this.data[key];

    if (!this.enabled) {
        return;
    }

    this.localStorage.removeItem(key);
};

DataLoader.prototype.cleanAll = function () {
    this._queue = {};
    this.data = {};
    this.checksum = 0;
    this.saveChecksum();

    const prefix = this.getLocalStoragePrefix();

    this.localStorage.clearData(prefix);
};

DataLoader.prototype.addChecksum = function (key, value) {
    if (key === DataLoader.TYPES.CHECKSUM) {
        return;
    }

    // eslint-disable-next-line no-bitwise
    this.checksum ^= cleverapps.hashCode(value);
};

DataLoader.prototype.loadChecksum = function () {
    return cleverapps.castType(this.load(DataLoader.TYPES.CHECKSUM));
};

DataLoader.prototype.saveChecksum = function () {
    this._saveProcess(DataLoader.TYPES.CHECKSUM, this.checksum);
};

DataLoader.prototype.getLocalStoragePrefix = function () {
    return cleverapps.config.name + connector.platform.getLocalStoragePrefix();
};

DataLoader.prototype.onCloudConflict = function () {
    const local = connector.cloudStorage.getLocalStorage();
    const cloud = connector.cloudStorage.getCloudStorage();

    const loadUser = (storage) => {
        let user = storage.getItem(DataLoader.TYPES.ID);
        if (user) {
            user = JSON.parse(user);
            user.episode = +user.episode || 0;
            user.level = +user.level || 0;
            user.exp = +user.exp || 0;
            user.progress = +user.progress || 0;
            user.progressCompare = +user.progressCompare || 0;
        }
        return user;
    };

    const loadMeta = (storage) => {
        let meta = storage.getItem(DataLoader.TYPES.META);
        if (meta) {
            meta = JSON.parse(meta);
            meta.knockoutLevel = meta.knockoutLevel || 0;
        }
        return meta;
    };

    const userLocal = loadUser(local);
    const userCloud = loadUser(cloud);

    const metaLocal = loadMeta(local);
    const metaCloud = loadMeta(cloud);

    console.log("compare cloud save: ", userLocal, userCloud);
    console.log("compare cloud meta: ", metaLocal, metaCloud);

    const choose = (() => {
        if (!userLocal && !userCloud) {
            return "equals";
        }
        if (!userLocal) {
            return "cloud";
        }
        if (!userCloud) {
            return "local";
        }

        let result = 0;

        if (["merge", "merge2", "farm"].includes(cleverapps.config.type)) {
            result = userLocal.level - userCloud.level || userLocal.exp - userCloud.exp;
        } else {
            result = userLocal.episode - userCloud.episode || userLocal.level - userCloud.level || userLocal.progress - userCloud.progress;
        }

        result = result || userLocal.progressCompare - userCloud.progressCompare;

        if (!result) {
            return "equals";
        }

        return result > 0 ? "local" : "cloud";
    })();

    connector.cloudStorage.conflictData = {
        localSnapshot: { users: userLocal, metha: metaLocal },
        remoteSnapshot: { users: userCloud, metha: metaCloud }
    };

    connector.cloudStorage.resolve(choose);
};

DataLoader.prototype.onCloudDisable = function () {
    this.setEnabled(false);
    this.needsReload = true;

    if (cleverapps.placements) {
        cleverapps.placements.run(Placements.SYSTEM_FAULT);
    }
};

DataLoader.REMOVE = -12345;
DataLoader.VALUE_LENGTH_LIMIT = 10 * 1000 * 1000;

DataLoader.TYPES = {
    ID: "",
    DATA_VERSION: "_data_version",
    HISTORY: "_history",
    CLIENT_SESSION: "_client_session",
    IDB_SESSION: "_idb_session",
    USERS_SYNCS: "_users_syncs",
    CHECKSUM: "_checksum",

    SETTINGS: "_settings",
    DAILY_CHEST: "_periodicBonus",
    TUTORIAL: "_tutorial",
    LEVEL_HINTS: "_level_hints",
    PRODUCT_VIDEO_PROGRESS: "_v_p_",
    GAME_SAVE: "_game_save",
    USER_IDS_HISTORY: "_ids_history",
    PAYMENTS_HISTORY_5_PRICE: "_my_payments_5_price",
    SALE_MANAGER: "_sale_manager",
    SALE: "_sale",
    SESSION_SAVE_KEY: "_session",
    PROMOTION: "_promotion",
    PROMOCODES: "_promocodes",
    LOCALIZATION_MANAGER: "_localization_manager",

    LIVES: "_lives",
    BOOSTERS: "_boosters_counter",
    BOOSTER_UNLOCK_WINDOWS: "_booster_unlock_windows",
    STAR_CHEST: "_star_chest",

    BONUS_EPISODES_PROGRESS: "_bonus_episodes_progress",

    VIP_LEVEL: "vip_level",

    SERVER_FLAGS: "_server_flags",
    BUY_MOVES_WINDOW: "_buy_moves_window",
    FORCES: "_forces",

    FREE_BOMB_MOVES: "_free_bomb_moves",

    UNLIMITED_LIVES: "_temp_goods",

    SORTER: "_sorter",

    CROSSPROMO: "_crosspromo",
    MINI_PROMO: "_mini_promo",
    REWARDEDPROMO: "_promotasks",
    VERSION_CHECKER: "_version_checker",
    GAME_ANNOUNCE: "_game_announce",
    FRIEND_REQUESTS: "_friend_requests",
    FRIEND_REQUESTS_SEND_TIME: "_friend_requests_send_time",
    FAKE_REQUESTS: "_fake_request_time",
    ASKED_LIVES: "_asked_lives",
    ASKED_STARS: "_asked_stars",
    SEND_GIFT: "_send_gift",

    PACK: "_pack",
    ACHIEVEMENTS: "_achievements",
    ACHIEVEMENTS_ATTENTION: "_achievements_attention",

    WIN_STREAK: "_win_seria",

    LOCAL_PUSHES: "_local_pushes",

    TOURNAMENT_COMPETITORS: "_tournament_competitors",
    TOURNAMENT_PLAYERS: "_tournament_players",
    TOURNAMENT_RECORD: "_tournament_record",

    PLAY_SESSION: "_play_session",

    AD_ICON: "_adicon",

    SPECIAL_LIVES_OFFER_LAST_TIME: "_special_energy_offer_last_time",

    ENERGY_BOOSTER: "_energy_booster",

    THIRD_ELEMENT_LAST_TIME: "_third_element_last_time",

    LEVEL_ATTEMPTS: "_level_attempts",

    MONSTER_PLANNER: "_monster_planner",
    GROWINGS_PLANNER: "_growings_planner",
    PATHINDICATOR_CELL: "_pathindicator_cell",

    LAST_VIEWED_FRIEND_REQUEST: "_last_viewed_friend_request",

    MISSIONS: "_missions",
    OFFERS: "_offers_data",
    COMPETITION: "_competition",
    COMPETITION_PLAYERS: "_competition_players",
    COMPETITION_STATISTICS: "_competition_statistics",
    MISSIONS_DAILY_REWARD: "_missions_daily_reward",

    PLACEMENTS: "_placements",

    SUBSCRIPTION: "_subscription",

    INSTANT_BOT_CREATED: "_instant_bot_created",

    HEROES: "_heroes",

    CUP: "_cup",
    CUP_RULES: "cup_rules",

    MINI_GAME_RECORD: "_mini_game_record",

    INFORMATION: "_info",
    SYNC: "_sync",

    FRIDAY_SALE: "_friday_sale",

    LANTERN: "_lantern",

    FARM: "_clockmaker_a",
    FISHDOM: "_fishdom",
    HOMEFIX: "_home",
    HOMEFIX_LEVEL: "_home_level",
    HOSE: "_hose",
    META: "_meta",
    LOCATION: "_location",
    SYSTORE: "_systore",

    KNOCKOUT: "_knockout",
    SHORTMETA: "_short",

    COOKIE_JAR: "_cookie_jar",

    RATED: "_rated",

    SIMPLE: "_simple",
    HIGHSCORE: "_loop", // backward compatibility

    JACKPOT_LAST_APPEAR_TIME: "_jackpot_last_appear_time",

    ADMIN_CHART: "_admin_chart",

    SCROLL: "_scroll",
    MAP2D: "_map2d",

    QUESTS: "_quests",

    UNIT_SAVER_KICKOUTS: "_unit_saver_kickouts",

    UNITS_LIBRARY: "_units_library",
    UNITS_SHOP: "_units_shop",
    WORKERS: "_workers",
    FREE_WORKER: "_free_worker",
    HARVESTED: "_harvested",
    FOGS: "_fogs",
    POCKET: "_pocket",

    ARMY_LIBRARY: "_armylib",

    CHAT: "_chat",
    CONSOLE_STREAM_START_TIME: "_console_stream_start_time",

    RESET_REPORT: "_reset_report",

    ADS_LIMITS_DATA: "_ads_limits_data",

    GAME_DATA: "_game_data",

    ABTEST: "_abtest",

    BARREL_PLANNER: "_barrel_planner",
    PIXELS_PLANNER: "_pixels_planner",
    THIRDELEMENTS_PLANNER: "_thirdelements_planner",

    BUBBLES: "_bubbles",

    TRAVEL_BOOK_EVENTS: "_travel_book_events_",
    TRAVEL_BOOK_ATTENTION: "_travel_book_attention_",
    INTRO_WINDOW_SHOWN: "_intro_window_shown_",

    UNKNOWN_UNIT_TEST: "_unknown_unit_test",
    UNKNOWN_ACHIEVEMENT_TEST: "_unknown_achievement_test",
    USER_CLAN: "_user_clan",

    SNAPSHOT_TIME_DELTA: "_snapshot_time_delta",

    ARMY: "_army",

    TROOP_CARDS: "_troop_cards",

    TRAVEL_BOOK: "_travel_book",

    USER_DELETE: "_user_delete",

    OFFER_PURCHASE_TIME: "_offer_purchase_time_",

    GAME_MODES: "_game_modes",

    LANDMARK_INFO: "_landmark_info",
    INSTANT_TOURNAMENT: "_instcup",

    SCORE: "_score",

    THROWERROR: "_debug_throwerror",

    TEST_SOUNDS: "_test_sounds",

    LAST_SUCCESSFUL_SHARE: "_last_successful_share",

    AD_OCEAN_TOKEN: "_ad_ocean_token",

    GIT: "_git",

    LAST_ONERROR: "_last_onerror",

    AD_FROZEN: "_ad_frozen",

    KPI_LOGGER: "_kpi_logger",

    FRAUD_DETECTOR: "_fraud_detector",

    STICKERS_BOOK_INFO: "_stickers_book_info",
    STICKERS_BOOK_ATTENTION: "_stickers_book_attention",

    STICKERS_BOOK2_INFO: "_stickers_book2_info",
    STICKERS_BOOK2_ATTENTION: "_stickers_book2_attention",
    STICKERS_BOOK2_PITY: "_stickers_book2_pity",

    NO_ADS: "_noads",
    NO_ADS_NUDGE_TIME: "_noads_nudge_time",

    COUNTRY: "_country",

    FRIENDS: "_friends",
    PAYMENTS_HISTORY: "_my_payments",
    AD_WATCH_COUNTER: "_adviews",

    RUMBLE: "_rumble",

    WEEKLY_TOURNAMENT: "_weekly_tournament",

    INVITE_ICON: "_invite_icon",

    IDB_TEST: "_idb_test",

    WEEKLY_GOALS: "_weekly_goals",
    WEEKLY_GOALS_LOGIN: "_weekly_goals_login",
    WEEKLY_GOALS_UNLOCKS: "_weekly_goals_unlocks",

    PERSONAL_BEST: "_personal_best",
    SIMPLE_ALGORITHM: "_simple_algorithm",
    ORDER_MANAGER: "_order_manager",
    CUSTOMERS_QUEUE: "_customers_queue",
    RAVE_REVIEWS: "_rave_reviews",

    TEST_CORRUPTED: "_test_corrupted",
    AD_BLOCK_WINDOW_LAST_SHOWN: "_ad_block_window_last_shown",
    HUNGRY_GAMES_MERGE2: "_hungry_games_merge2",
    HUNGRY_GAMES_STATISTICS: "_hungry_games_statistics",
    BALLOON_RISE_MERGE2: "_balloon_rise_merge2",

    NEW_LEVELS_EXPLANATION_SHOWN: "_new_levels_explanation_shown",
    METRICS: "_metrics",

    CANVAS_USER_ID: "_canvas_user_id"
};

if (typeof cc === "undefined") {
    module.exports = DataLoader;
}